export const colors =  {
  background: '#ffffff',
  primaryColor: '#4D4D4D',
  secondaryColor: '#7E7E7E',
  warning: '#DE350B',
}
